<div class="coin_details zindex h-100">
  <div class="card trade_card h-100 position-relative">

    <div class="card-header d-flex justify-content-between align-items-center py-2 border-bottom border-secondary">
      <h5 class="mb-0 text-white">Bot Opportunity</h5>
      <button class="btn d-flex align-items-center p-1 ps-2 pe-3 rounded border border-secondary"
        style="background-color: #1e2026;" (click)="downloadExcel('')" [disabled]="isDownloading">
        <div class="rounded me-2 d-flex align-items-center justify-content-center"
          style="background-color: rgba(56, 189, 248, 0.1); width: 28px; height: 28px;">
          <i class="bi bi-file-earmark-arrow-down" style="color: #38bdf8;"></i>
        </div>
        <div class="text-start lh-1">
          <p class="mb-0 text-secondary" style="font-size: 0.6rem; text-transform: uppercase;">Action</p>
          <span class="text-white" style="font-size: 0.75rem;">CSV Export</span>
        </div>
      </button>
    </div>

    <div class="card-body p-0 d-flex align-items-center" style="overflow: hidden;">

      <div class="slider-wrapper w-100 h-100 d-flex align-items-center px-3">

        <div class="slide-card p-3 me-3 rounded border border-secondary position-relative"
          *ngFor="let pair of topGainers | textFilter: 'tikerRoot': searchPair; trackBy: trackBySymbol"
          (click)="changePair(pair)" [ngClass]="{'active-card': selectedPair?.symbol === pair.symbol}">

          <div class="d-flex justify-content-between align-items-center mb-3">
            <span class="fw-bold fs-6" [ngClass]="pair.isProfit ? 'text-success' : 'text-white'">
              {{ pair.symbol }}
            </span>
            <small class="text-secondary" style="font-size: 0.65rem;">
              {{ dateTimeFormat(pair.createdAt) }}
            </small>
          </div>

          <div class="row g-0 mb-3">
            <div class="col-6 border-end border-secondary pe-2">
              <div class="text-secondary small" style="font-size: 0.65rem;">Price</div>
              <div class="text-white fw-bold" style="font-size: 0.9rem;">
                {{ nFormatter(truncateDecimals(pair.price, 2)) }}
              </div>
            </div>
            <div class="col-6 ps-2 text-end">
              <div class="text-secondary small" style="font-size: 0.65rem;">Vol (USDT)</div>
              <div class="text-white" style="font-size: 0.9rem;">
                {{ nFormatter(truncateDecimals(pair.volumeUSDT, 2)) }}
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-center pt-2 border-top border-secondary">
            <div class="d-flex align-items-center">
              <span class="badge bg-dark border border-secondary text-secondary me-1" style="font-size: 0.6rem;">
                {{ getMinutesDiff(pair?.createdAt) }}m
              </span>
              <span class="text-white small">{{ nFormatter(truncateDecimals(pair.change, 2)) }}%</span>
            </div>
            <div class="text-end">
              <span class="fw-bold" [ngClass]="pair.currentPercentage > 0 ? 'text-success' : 'text-danger'">
                {{ nFormatter(truncateDecimals(pair.currentPercentage, 4)) }}%
              </span>
            </div>
          </div>

        </div>
        <div *ngIf="topGainers.length === 0" class="w-100 text-center text-secondary">
          <p>No opportunities found.</p>
        </div>

      </div>
    </div>
  </div>
</div>